import { h } from "preact";
import { Link } from "react-router-dom";

import i18n from "../i18n.js";
import Icon from "./Icon.jsx";

export default function WhitepaperLearnMoreTeaser({ whitepaper }) {
  return (
    <article class="similar-post mb-48">
      <h4 class="t-subtitle1 t-subtitle1--margin">{whitepaper.title}</h4>
      <p class="t-body2 mt-0">{whitepaper.excerpt}</p>
      <Link
        class="inline-flex-center subtle t-body3"
        to={`/whitepaper/${encodeURIComponent(whitepaper.id)}`}
      >
        <Icon class="mr-32">arrow_forward</Icon>
        {i18n.t("actions.read_more")}
      </Link>
    </article>
  );
}
